// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

// The path Fleet Tracing used to live at. Kept only so old links resolve.
const baseRoute = '/fleet-tracing'

export const BaseFleetTracingRedirectAreaRoutes = {
  route: baseRoute,
  Vehicle: {
    route: '/vehicle',
  },
}

export const FleetTracingRedirectAreaRoutes = transformRoutes(
  BaseFleetTracingRedirectAreaRoutes,
)
